import React, { useEffect, useRef } from "react";
import "aos/dist/aos.css";
import AOS from "aos";
import firstSectionRightMobile from "assets/images/first_section_right.jpg";
import firstSectionRightDesktop from "assets/images/first_section_right_button.jpg";
import qrCode from "assets/images/qrcode.png";
import qrcode from "assets/images/qrcode(1).png";
import iosButton from "assets/images/ios_button.png";
import googleButton from "assets/images/google_button.png";
import huaweiButton from "assets/images/huawei_button.png";
import savingsImage from "assets/images/3_3_savings.jpg";
import savingsPot from "assets/images/fourth_section_2.jpg";
import openAccountImg from "assets/images/Open-a-savings-account_web.svg";
import manageFinancesImg from "assets/images/Manage-your-finances_web.svg";
import subscribeActivateImg from "assets/images/Subscribe-and-activate_web.svg";
import instantTransfersImg from "assets/images/Make-instant-transfers_web.svg";
import unlockRewardsImg from "assets/images/Unlock-great-rewards_web.svg";
import { Link } from "react-router-dom";
import RizeAd from "sections/Home/RizeAd";
import { ASSETS_BASE_URL } from "constants";

const Rize = () => {
  const showcaseRef = useRef(null);
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <style>
        {`
      .showcase {
      height: max-content
      }
      .fontresizeheader  {
            font-size: 4rem
            } 
      .fontresizeheaderdownload  {
            font-size: 4rem
            }
       .fontresizesubheader {
            font-size: 1.8rem
            }

    @media (min-width: 768px) {
            .fontresizeheader  {
            font-size: 5.5vh
            }
            .fontresizeheaderdownload  {
            font-size: 4rem
            }
             .fontresize {
            font-size: 18px
            }
            .fontresizesubheader {
            font-size: 1.8rem
            }

            .rize-section{
            padding: 8rem;

            }
             .rize-download{
           height: 60%
            }
    }

    @media (max-width: 767px) {
     .fontresizeheader {
            font-size: 2rem;
            }
     .fontresizeheaderdownload  {
            font-size: 2rem
            }
     .fontresize {
            font-size: 14px
            }
    .fontresizesubheader {
            font-size: 25px
            }
     .rize-section{
            padding: 50px;
            }
      .rize-download{
           height: 22rem;
            }
    }`}
      </style>

      <section className="showcase" ref={showcaseRef}>
        <div className="container-fluid p-0">
          <div className="row g-0">
            <div className="col-lg-6 rize-section my-auto order-lg-1 showcase-text">
              <span
                className="fontresizeheader"
                style={{
                  color: "#ff5800",
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 900,
                  marginTop: "1em",
                  gap: "0",
                }}
              >
                Reimagining
                <br /> 21st century
                <br /> banking
              </span>
              <p
                className="lead mb-0 fontresize aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingTop: "13px",
                  fontSize: "18px",
                  fontWeight: "300",
                }}
              >
                Experience a new way of banking with Rize, a digital bank
                powered by
                <a
                  href="https://www.alrajhibank.com.my/"
                  style={{
                    color: "#221afb",
                    marginLeft: "2px",
                    marginRight: "2px",
                    textDecoration: "none",
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Al Rajhi Banking & Investment Corporation (Malaysia) Bhd
                </a>
                , the world’s largest Islamic bank.
              </p>
              <p
                className="lead mb-0 fontresize aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingTop: "13px",
                  fontSize: "18px",
                  fontWeight: "300",
                }}
              >
                Open a savings account anywhere, anytime and do so much more to
                make your dreams a reality.
              </p>
              <p
                className="lead mb-0 fontresize aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingTop: "13px",
                  fontSize: "18px",
                  fontWeight: "300",
                }}
              >
                <span style={{ fontWeight: "bold" }}>We’re digital-only,</span>{" "}
                so you’ll never have to visit a branch. Activate your account
                today on our Rize app and start earning one of Malaysia’s best
                profit rates in minutes!
              </p>
              <p
                className="lead mb-0 fontresize aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingTop: "13px",
                  fontSize: "18px",
                  fontWeight: "300",
                }}
              >
                It's time to{" "}
                <span style={{ fontWeight: "bold" }}>Discover Your More</span>.
                <span style={{ marginTop: "1em" }}>&nbsp;</span>
              </p>
            </div>
            <div className="col-lg-6 text-white order-lg-2 showcase-img">
              <span></span>
              {/* Mobile */}
              <img
                className="img-fluid d-lg-none d-md-none d-sm-block"
                style={{ marginBottom: "2.5rem" }}
                src={`${ASSETS_BASE_URL}assets/images/rize/first_section_right_button.png`}
                alt="First Section Right Mobile"
              />
              {/* Desktop */}
              <img
                className="img-fluid d-none d-md-block d-lg-block"
                style={{ background: "#963c3c" }}
                src={`${ASSETS_BASE_URL}assets/images/rize/first_section_right_button.png`}
                alt="First Section Right Desktop"
              />
              {/* Mobile Button Card */}
              <div
                className="col-12 bg-image card d-block d-md-none d-sm-block"
                style={{
                  position: "absolute",
                  display: "block",
                  marginTop: "-7em",
                  backgroundColor: "rgba(255,255,255,0)",
                  border: "0px",
                }}
              >
                <div className="card-body text-white">
                  <p className="card-text">
                    <img
                      className="d-lg-block d-none"
                      src={qrCode}
                      style={{ width: "12em" }}
                      alt="QR Code"
                    />
                  </p>
                  {/* <center>
                    <div className="ccm-custom-style-container ccm-custom-style-firstsectionbuttons-359">
                      <p>
                        <a
                          href="https://apps.apple.com/app/rize-my/id1587293861"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={iosButton}
                            alt="iOS Button"
                            width="412"
                            height="auto"
                            style={{ width: "5em" }}
                          />
                        </a>
                        &nbsp; &nbsp; &nbsp;
                        <a
                          href="https://play.google.com/store/apps/details?id=my.com.alrajhibank.wick"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={googleButton}
                            alt="Google Button"
                            width="412"
                            height="auto"
                            style={{ width: "5em" }}
                          />
                        </a>
                        &nbsp; &nbsp; &nbsp;
                        <a
                          href="https://appgallery.huawei.com/app/C104770227"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={huaweiButton}
                            alt="Huawei Button"
                            width="412"
                            height="auto"
                            style={{ width: "5em" }}
                          />
                        </a>
                        &nbsp;&nbsp;
                      </p>
                    </div>
                  </center> */}
                </div>
              </div>
              {/* End of Mobile Button Card */}
            </div>
          </div>
        </div>
      </section>

      <section id="profitrate" className=" showcase">
        <div className="container-fluid p-0">
          <div className="row g-0" style={{ marginTop: "-3em" }}>
            <div className="xs-margin visible-xs"></div>
            <div
              className="col-lg-6 text-white order-lg-1 showcase-img"
              style={{ background: "#E4F5FC" }}
            >
              <span>
                <img
                  className="img-fluid aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-delay="150"
                  style={{
                    background: "#E4F5FC",
                    paddingTop: "0px",
                    marginTop: "0px",
                  }}
                  src={`https://www.alrajhibank.com.my/assets/images/rize/3_3_savings.jpg`}
                  alt="Savings"
                />
              </span>
            </div>
            <div className="col-lg-6 mt-5 pt-5 rize-section order-lg-2 showcase-text">
              <h2
                className="lead mb-0 fontresizesubheader aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  fontWeight: "500",
                }}
              >
                <span style={{ fontWeight: "bold" }}>
                  Still one of the best offers in town!
                </span>
              </h2>
              <h1
                className="lead mb-0 fontresizeheader aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingTop: "13px",
                  fontWeight: "500",
                }}
              >
                <span style={{ fontWeight: "bold" }}>3.3% profit p.a.*</span>
              </h1>
              <p
                className="lead mb-0 fontresize aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingTop: "13px",
                  fontWeight: "500",
                }}
              >
                Earn{" "}
                <span style={{ fontWeight: "bold" }}>3.3% profit p.a.*</span> on
                your Rize Savings Account-<i>i</i>**
              </p>
              <p
                className="lead mb-0 fontresize aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingTop: "13px",
                  fontWeight: "500",
                }}
              >
                <span style={{ fontWeight: "bold" }}>Step 1</span>: Download
                Rize from your respective app store
              </p>
              <ul style={{ marginLeft: "1em" }}>
                <li
                  className="lead mb-0 fontresize aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#7f6c59",
                    paddingTop: "13px",
                    fontWeight: "500",
                  }}
                >
                  <a
                    href="https://apps.apple.com/app/rize-my/id1587293861"
                    style={{
                      color: "#221afb",
                      marginLeft: "2px",
                      textDecoration: "none",
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    App Store
                  </a>
                </li>
                <li
                  className="lead mb-0 fontresize aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#7f6c59",
                    paddingTop: "13px",
                    fontWeight: "500",
                  }}
                >
                  <a
                    href="https://play.google.com/store/apps/details?id=my.com.alrajhibank.wick"
                    style={{
                      color: "#221afb",
                      marginLeft: "2px",
                      textDecoration: "none",
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Google Play Store
                  </a>
                </li>
                <li
                  className="lead mb-0 fontresize aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#7f6c59",
                    paddingTop: "13px",
                    fontWeight: "500",
                  }}
                >
                  <a
                    href="https://appgallery.huawei.com/app/C104770227"
                    style={{
                      color: "#221afb",
                      marginLeft: "2px",
                      textDecoration: "none",
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Huawei AppGallery
                  </a>
                </li>
              </ul>
              <p
                className="lead mb-0 fontresize aos-init aos-animate"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingTop: "13px",
                  fontWeight: "500",
                }}
              >
                <span style={{ fontWeight: "bold" }}>Step 2</span>: Sign up for
                a Rize Savings account-<i>i</i>
              </p>
              <p
                className="lead mb-0 fontresize aos-init aos-animate"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingTop: "13px",
                  fontWeight: "500",
                }}
              >
                <span style={{ fontWeight: "bold" }}>Step 3</span>: Activate the
                account by depositing a minimum of RM20
              </p>
              <p
                className="lead mb-0 fontresize aos-init aos-animate"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingTop: "13px",
                  fontWeight: "500",
                }}
              >
                <span style={{ fontWeight: "bold" }}>Step 4</span>: Earn a 3.3%
                profit rate p.a.* on any account balance!
              </p>
              <p
                className="lead mb-0 fontresize aos-init aos-animate"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingTop: "13px",
                  fontWeight: "500",
                }}
              >
                <span style={{ fontWeight: "bold" }}>
                  *alrajhi bank Malaysia General Terms & Conditions apply,
                  click&nbsp;
                  <Link
                    to="/tnc"
                    style={{
                      color: "#221afb",
                      textDecoration: "none",
                      marginLeft: "2px",
                      marginRight: "2px",
                      fontWeight: "bold",
                    }}
                  >
                    here
                  </Link>
                  &nbsp;for full details.
                </span>
              </p>
              <p
                className="lead mb-0 fontresize aos-init aos-animate"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingTop: "13px",
                  fontWeight: "500",
                }}
              >
                <span style={{ fontWeight: "bold" }}>
                  **Commodity Murabahah Savings Account-<i>i</i>.
                </span>
              </p>
              <p
                className="lead mb-0 fontresize aos-init aos-animate"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingTop: "13px",
                  fontWeight: "500",
                }}
              >
                Rize Commodity Murabahah Savings Account-<i>i</i> Board Rate:
                3.3% profit rate p.a.
              </p>
            </div>
          </div>
        </div>
      </section>

      <RizeAd showcaseRef={showcaseRef} />

      <section id="sectionsavings" className="py-4  py-xl-5 showcase">
        <div className="container-fluid p-0">
          <div className="row g-0" style={{ marginTop: "-6em" }}>
            <div className="xs-margin visible-xs"></div>
            <div className="col-lg-6 text-white order-lg-2 showcase-img">
              <span>
                <img
                  id=""
                  className="img-fluid aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-delay="150"
                  style={{
                    marginTop: "4rem",
                  }}
                  src={`${ASSETS_BASE_URL}assets/images/rize/fourth_section_2.png`}
                  alt="Savings Pot"
                />
              </span>
            </div>
            <div className="col-lg-6 order-lg-1 rize-section showcase-text">
              <h1
                data-aos="fade-up"
                data-aos-delay="100"
                className="fontresizeheader reducetextspace aos-init aos-animate"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 900,
                  color: "#ff5800",
                }}
              >
                <p>SAVINGS POT</p>
              </h1>
              <h1
                data-aos="fade-up"
                data-aos-delay="150"
                className="fontresizesubheader aos-init aos-animate"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#ff7c2e",
                  fontWeight: 600,
                }}
              >
                <p>
                  Malaysia’s first&nbsp;digital&nbsp;bank savings pot with a
                  <b>&nbsp;</b>profit rate.
                </p>
              </h1>
              <p
                className="lead mb-0 fontresize aos-init"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "#7f6c59",
                  paddingBottom: "5px",
                  fontWeight: 500,
                }}
              >
                Create up to 10 savings pots for all your life goals and review
                your progress every step of the way. Get friends and family to
                chip in so you can reach those goals sooner.
              </p>
              <ul style={{ background: "#FFF2E6" }}>
                <li
                  className="lead mb-0 fontresize aos-init"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    color: "rgb(127, 108, 89)",
                    paddingTop: "15px",
                    fontWeight: 500,
                  }}
                >
                  Fully digital &amp; paperless: hassle-free document uploads
                  via app
                </li>
                <li
                  className="lead mb-0 fontresize aos-init"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    color: "rgb(127, 108, 89)",
                    paddingTop: "5px",
                    fontWeight: 500,
                  }}
                >
                  Multiple contribution feature to achieve your life goals
                  faster
                </li>
                <li
                  className="lead mb-0 fontresize aos-init"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    color: "rgb(127, 108, 89)",
                    paddingTop: "5px",
                    paddingBottom: "15px",
                    fontWeight: 500,
                  }}
                >
                  Extensive personal finance management tools
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="container showcase">
        <div
          className="container"
          style={{
            // width: "100vw",
            height: "max-content",
            // marginBottom: "2em",
          }}
        >
          <div className="row mb-4 align-items-center mb-lg-5">
            <div className="col-12">
              <h1
                data-aos="fade-up"
                data-aos-delay="100"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 900,
                  color: "#0067ee",
                  marginTop: "2em",
                }}
                className="aos-init"
              >
                <p className="fontresizeheader" style={{ textAlign: "center" }}>
                  Be more today than you were yesterday
                </p>
              </h1>
            </div>
          </div>
          <div className="row gy-4 row-cols-1 row-cols-md-3 justify-content-center  pb-5">
            <div className="col">
              <div className="card border-0 shadow-none">
                <div
                  className="card-body text-center d-flex flex-column align-items-center p-0 aos-init"
                  data-aos="fade-up"
                  data-aos-delay="150"
                >
                  <img
                    src={`${ASSETS_BASE_URL}assets/images/rize/personal/Rize-illustration-1.svg`}
                    alt="Open a savings account"
                    width="270"
                    height="132"
                    className="img-fluid fit-cover"
                  />
                  <h5
                    className="fw-bold card-title mb-0 fontresizesubheadericon"
                    style={{
                      color: "#0067ee",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: "bold",
                      fontSize: "2vh",
                    }}
                  >
                    <strong>Open a savings account</strong>
                  </h5>
                  <p
                    className="card-text mb-0 fontresizeicon"
                    style={{
                      color: "#7f6c59",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "2vh",
                    }}
                  >
                    within minutes, anytime, anywhere.
                  </p>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card border-0 shadow-none">
                <div
                  className="card-body text-center d-flex flex-column align-items-center p-0 aos-init"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <img
                    src={`${ASSETS_BASE_URL}assets/images/rize/personal/Rize-illustration-2.svg`}
                    alt="Manage your finances"
                    width="270"
                    height="132"
                    className="img-fluid fit-cover"
                  />
                  <h5
                    className="fw-bold card-title mb-0 fontresizesubheadericon"
                    style={{
                      color: "#ff7c2e",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: "bold",
                      fontSize: "2vh",
                    }}
                  >
                    <strong>Manage your finances</strong>
                  </h5>
                  <p
                    className="card-text mb-0 fontresizeicon"
                    style={{
                      color: "#7f6c59",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "2vh",
                      fontWeight: 400,
                    }}
                  >
                    with financial management insights.
                  </p>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card border-0 shadow-none">
                <div
                  className="card-body text-center d-flex flex-column align-items-center p-0 aos-init"
                  data-aos="fade-up"
                  data-aos-delay="250"
                >
                  <img
                    src={`${ASSETS_BASE_URL}assets/images/rize/personal/Rize-illustration-3.svg`}
                    alt="Subscribe and activate"
                    width="270"
                    // height="250"
                    className="img-fluid fit-cover"
                  />
                  <h5
                    className="fw-bold card-title mb-0 fontresizesubheadericon"
                    style={{
                      color: "#00a200",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: "bold",
                      fontSize: "2vh",
                    }}
                  >
                    <strong>Subscribe and activate</strong>
                  </h5>
                  <p
                    className="card-text mb-0 fontresizeicon"
                    style={{
                      color: "#7f6c59",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "2vh",
                      fontWeight: 400,
                    }}
                  >
                    your debit card on-app.
                  </p>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="card border-0 shadow-none">
                <div
                  className="card-body text-center d-flex flex-column align-items-center p-0 aos-init"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <img
                    src={`${ASSETS_BASE_URL}assets/images/rize/personal/Rize-illustration-4.svg`}
                    alt="Make instant transfers"
                    width="270"
                    height="132"
                    className="img-fluid fit-cover"
                  />
                  <h5
                    className="fw-bold card-title mb-0 fontresizesubheadericon"
                    style={{
                      color: "#309fed",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: "bold",
                      fontSize: "2vh",
                    }}
                  >
                    <strong>Make instant transfers</strong>
                  </h5>
                  <p
                    className="fw-light card-text mb-0 fontresizeicon"
                    style={{
                      color: "#7f6c59",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "2vh",
                      fontWeight: 400,
                    }}
                  >
                    <strong>using DuitNow transfer or DuitNow QR.</strong>
                  </p>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="card border-0 shadow-none">
                <div
                  className="card-body text-center d-flex flex-column align-items-center p-0 aos-init"
                  data-aos="fade-up"
                  data-aos-delay="350"
                >
                  <img
                    src={`${ASSETS_BASE_URL}assets/images/rize/personal/Rize-illustration-5.svg`}
                    alt="Unlock great rewards"
                    width="270"
                    height="132"
                    className="img-fluid fit-cover"
                  />
                  <h5
                    className="fw-bold card-title mb-0 fontresizesubheadericon"
                    style={{
                      color: "#ff5800",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 900,
                      fontSize: "2vh",
                    }}
                  >
                    <strong>Unlock great rewards</strong>
                  </h5>
                  <p
                    className="fw-light card-text mb-0 fontresizeicon"
                    style={{
                      color: "#7f6c59",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: "2vh",
                      fontWeight: 400,
                    }}
                  >
                    <strong>and amazing deals.</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="text-center rize-download text-white call-to-action pt-5 pb-0"
        id="download"
        style={{ background: "#e6f5fb" }}
      >
        <div
          style={{
            paddingBottom: "0px",
            background: "#d7e7f8",
            borderColor: "#e6f5fb",
            fontFamily: "Poppins, sans-serif",
            marginTop: "-1px",
          }}
        ></div>
        <div className="container">
          <div className="row">
            <div
              className="col-xl-9 mx-auto position-relative aos-init"
              data-aos="fade-up"
              data-aos-delay="150"
            >
              <h1
                className="mb-4 fontresizeheaderdownload"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 900,
                  color: "#0067ee",
                }}
              >
                <div className="ccm-custom-style-container ccm-custom-style-downloadsectionheader-271">
                  <p>Download Rize now</p>
                </div>
              </h1>
              <center>
                <p>
                  <img
                    src={qrcode}
                    alt="QR Code"
                    width="231"
                    height="258"
                    className="d-md-block d-none"
                    style={{
                      width: "12em",
                      height: "auto",
                      marginBottom: "29px",
                      padding: "10px",
                    }}
                  />
                </p>
              </center>
              <div className="row p-0 m-0">
                <div className="col" style={{ paddingBottom: "0px" }}>
                  <div className="ccm-custom-style-container  ccm-custom-style-downloadsectionbuttons-353">
                    <p>
                      <a
                        href="https://apps.apple.com/app/rize-my/id1587293861"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={iosButton}
                          alt="Download on iOS"
                          width="200vw"
                          height="auto"
                          style={{ paddingRight: "10px", paddingLeft: "10px" }}
                        />
                      </a>
                      <a
                        href="https://play.google.com/store/apps/details?id=my.com.alrajhibank.wick"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={googleButton}
                          alt="Download on Google Play"
                          width="200vw"
                          height="auto"
                          style={{
                            paddingRight: "10px",
                            paddingLeft: "10px",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                          }}
                        />
                      </a>
                      <a
                        href="https://appgallery.huawei.com/app/C104770227"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={huaweiButton}
                          alt="Download on Huawei"
                          width="200vw"
                          height="auto"
                          style={{ paddingRight: "10px", paddingLeft: "10px" }}
                        />
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Rize;
